import React from 'react';
import {  Error, LabelTextarea, StyledTextarea, StyledTextareaWrapper } from './styled';
import { TTextareaProps } from './types';



export const TextArea = ({
    name,
    label,
    errorText,
    isInvalid,
    value,
    className,
    ...props
}: TTextareaProps) => {
    return (
        <StyledTextareaWrapper>
            <StyledTextarea
                autoComplete="off"
                id={name}
                name={name}
                value={value}
                placeholder=" "
                component="textarea"
                rows="6"
                {...props}
            />
            {label && (
                <LabelTextarea htmlFor={name}>
                    {label}
                </LabelTextarea>
            )}
            {isInvalid && errorText && <Error>{errorText}</Error>}
        </StyledTextareaWrapper>
    );
};
